import { render } from "./TenantsPickerMenu.vue?vue&type=template&id=0d1c63ae"
import script from "./TenantsPickerMenu.vue?vue&type=script&lang=js"
export * from "./TenantsPickerMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__